export const HELLO_PRIMARY_COLOR = "#003498"; //navy
export const HELLO_SECONDARY_COLOR = "#00b768"; //green
export const HELLO_TERTIARY_COLOR = "#fff"; //white
export const HELLO_PULSE_COLOR = "#FFB500" //vibrant orange
export const HELLO_PRIMARY_LIGHT_COLOR = "#6651C1" // light navy
export const HELLO_HIGHLIGHT_COLOR = "#FFB500"



